import React from "react";
import { useTranslation } from "react-i18next";
import { GameSettingBaseProps } from "components/common/GameSettingModal";
import SocketService from "network/SocketService";
import SocketProtocol from "network/SocketProtocol";

const QuizGameSettingBody: React.FC<GameSettingBaseProps> = ({ 
  setGameSetting,
  roomParams,
  aiCount 
}) => {
  const { t } = useTranslation();

  const handleAI = (add: boolean) => {
    SocketService.getInstance().emit(
      SocketProtocol.ADD_AI_PLAYER,
      roomParams.product.id,
      roomParams.room.roomName,
      add
    );
  };

  return (
    <div className="space-y-6 p-4">
      {/* AI 플레이어 설정 */}
      <div className="flex items-center justify-center gap-4">
        <div className="text-gray-200 min-w-[80px] text-sm">
          {t("aiPlayer")}
        </div>
        <div className="flex items-center gap-1 px-2 bg-gray-700 rounded-lg">
          <button
            className="w-8 h-8 text-white text-lg hover:bg-gray-600 rounded-l-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            onClick={() => handleAI(false)}
            disabled={aiCount <= 0}
          >
            –
          </button>
          <span className="text-white min-w-[40px] text-center py-1 text-sm">
            {aiCount}
          </span>
          <button
            className="w-8 h-8 text-white text-lg hover:bg-gray-600 rounded-r-lg transition-colors flex items-center justify-center"
            onClick={() => handleAI(true)}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizGameSettingBody;